"use client";
import styles from "./ProductSizeAndFitSideDrawer.module.scss";
import { Attribute } from "@/types/prodcatBaseTypes";
import { SEOFriendlyDrawer } from "../__shared__/SEOFriendlyDrawer/SEOFriendlyDrawer";
import { Trigger } from "../__shared__/Trigger/Trigger";
import { useState } from "react";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

type Props = {
  attributes: Attribute[];
  productType: string;
};

export function ProductSizeAndFitSideDrawerUI({
  attributes,
  productType,
}: Props) {
  const [open, setOpen] = useState(false);
  if (productType === "RetiredStaticBundle") return null;
  if (attributes.length === 0) return null;

  return (
    <>
      <Trigger
        label="Size and fit"
        onClick={withSideDrawerAnalytics("Size & Fit", () => setOpen(true))}
      />
      <SEOFriendlyDrawer
        isOpen={open}
        onClose={() => setOpen(false)}
        heading="Size and fit"
        primaryButtonText="Close"
      >
        <dl
          data-testid="product:size-and-fit:list"
          className={styles.productSizeAndFitList}
        >
          {attributes.map((attr) => (
            <div key={attr.key} className={styles.listItem}>
              <dt
                data-testid="product:size-and-fit:list:label"
                className={styles.listTitle}
              >
                {attr.displayName || attr.key} -{" "}
              </dt>
              <dd
                data-testid="product:size-and-fit:list:value"
                className={styles.listDesc}
              >
                {attr.values}
              </dd>
            </div>
          ))}
        </dl>
      </SEOFriendlyDrawer>
    </>
  );
}
